// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"fb7a09e3","623":"12875878","916":"3fa98dc8"}[chunkId] + ".chunk.css";
};